import { useRef, useState, useEffect, useCallback } from "react";
import { FunnelConfigTypes } from "../../funnel/types";
import { FUNNEL_ANIMATION_DURATION_MS } from "../constants";

interface UseSlideInFunnelProps {
  onFunnelChange?: (funnelConfig: FunnelConfigTypes | undefined) => void;
  goBack?: () => void;
}

export function useSlideInFunnel({
  onFunnelChange,
  goBack,
}: UseSlideInFunnelProps) {
  const [funnelConfig, setFunnelConfig] = useState<FunnelConfigTypes>();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // Notify parent component of funnel changes
  useEffect(() => {
    onFunnelChange?.(funnelConfig);
  }, [funnelConfig, onFunnelChange]);

  // Scroll to top when funnel changes
  useEffect(() => {
    if (funnelConfig && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [funnelConfig?.type]);

  const closeFunnel = useCallback(() => {
    setFunnelConfig(undefined);
  }, []);

  const handleBack = funnelConfig?.type ? closeFunnel : goBack;

  return {
    funnelConfig,
    setFunnelConfig,
    scrollContainerRef,
    closeFunnel,
    handleBack,
    hasFunnel: !!funnelConfig?.type,
  };
}

// Animation variants for funnel transitions
export const funnelAnimationVariants = {
  initial: { opacity: 0, scale: 0.98 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.98 },
};

export const menuAnimationVariants = {
  initial: { opacity: 0, scale: 0.98, filter: "brightness(1.3)" },
  animate: { opacity: 1, scale: 1, filter: "brightness(1)" },
  exit: { opacity: 0, scale: 0.98, filter: "brightness(1.3)" },
};

export const transitionConfig = {
  duration: FUNNEL_ANIMATION_DURATION_MS / 1000,
};
